import React, { FC } from 'react'

import { ConfirmationDialog } from 'components/dialog/ConfirmationDialog'

import styles from './ConfirmLogoutModalView.module.scss'
import { useSelector } from 'react-redux'
import * as meSelectors from 'store/statics/me/meSelectors'

interface Props {
  isConfirmationLogoutModalOpen: boolean
  handleConfirmLogout: () => void
  handleCancelLogout: () => void
}

export const ConfirmLogoutModalView: FC<Props> = ({
  isConfirmationLogoutModalOpen,
  handleConfirmLogout,
  handleCancelLogout,
}) => {
  const user = useSelector(meSelectors.getStatic)
  const firstName = user?.firstName
  const lastName = user?.lastName

  return (
    <ConfirmationDialog
      title="Start New Application"
      show={isConfirmationLogoutModalOpen}
      onConfirm={handleConfirmLogout}
      onHide={handleCancelLogout}
      confirmBtnLabel="Start"
      backdrop="static"
      className={styles.modal}
      isCustomCloseButton>
      You have an active session as&nbsp;
      <b>
        {firstName} {lastName}
      </b>
      . If you start a new application, you will be logged out.
    </ConfirmationDialog>
  )
}
